var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8FuturamaBender1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.56 30H5.44004C5.38071 30 5.33337 29.9527 5.33337 29.8934V12C5.33337 7.21337 9.21337 3.33337 14 3.33337C18.7867 3.33337 22.6667 7.21337 22.6667 12V21.8934C22.6667 21.952 22.6194 22 22.56 22H20.7734C20.714 22 20.6667 22.0474 20.6667 22.1067V29.8934C20.6667 29.9527 20.6194 30 20.56 30Z",
    fill: "#FFDD64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 2H12.6666V4.66667H15.3333V2Z",
    fill: "#FFDD64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 3.44604C14.8973 3.37871 14.4546 3.33337 14 3.33337C13.5453 3.33337 13.1026 3.37871 12.6666 3.44604V4.66671H15.3333V3.44604Z",
    fill: "#FC9F35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 20H10.6667C9.194 20 8 18.806 8 17.3334V12C8 10.5274 9.194 9.33337 10.6667 9.33337H20.6667C23.612 9.33337 26 11.7214 26 14.6667C26 17.612 23.612 20 20.6667 20Z",
    fill: "#FC9F35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 28H11C9.34333 28 8 26.6567 8 25C8 23.3433 9.34333 22 11 22H20.6667V28Z",
    fill: "#C4FFE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18H13C11.3433 18 10 16.6567 10 15C10 13.3433 11.3433 12 13 12H21C22.6567 12 24 13.3433 24 15C24 16.6567 22.6567 18 21 18Z",
    fill: "#126C46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15C10 16.6567 11.3433 18 13 18H21C21.06 18 21.116 17.986 21.1753 17.9827C21.6907 17.3507 22 16.5453 22 15.6667C22 13.6413 20.3587 12 18.3333 12C17.2813 12 16.3353 12.4453 15.6667 13.1553C14.998 12.4453 14.052 12 13 12C11.3433 12 10 13.3433 10 15Z",
    fill: "#C3FFE6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 16C13.0349 16 13.3333 15.7015 13.3333 15.3333C13.3333 14.9651 13.0349 14.6666 12.6667 14.6666C12.2985 14.6666 12 14.9651 12 15.3333C12 15.7015 12.2985 16 12.6667 16Z",
    fill: "#126C46"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16C18.3682 16 18.6667 15.7015 18.6667 15.3333C18.6667 14.9651 18.3682 14.6666 18 14.6666C17.6319 14.6666 17.3334 14.9651 17.3334 15.3333C17.3334 15.7015 17.6319 16 18 16Z",
    fill: "#126C46"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 22H10.6666V28H12.6666V22Z",
    fill: "#3DE8A0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 22H14.6666V28H16.6666V22Z",
    fill: "#3DE8A0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 22H18.6666V28H20.6666V22Z",
    fill: "#3DE8A0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 28H10.6666V30H12.6666V28Z",
    fill: "#126C46"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 28H14.6666V30H16.6666V28Z",
    fill: "#126C46"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 28H18.6666V30H20.6666V28Z",
    fill: "#126C46"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FuturamaBender1);
export default __webpack_public_path__ + "static/media/icons8-futurama-bender-1.e24204d561b0be57b7a81800faeeb543.svg";
export { ForwardRef as ReactComponent };